export const deferredPromptSelector = ({deferredPrompt}) => deferredPrompt